import * as React from 'react';
import { PageSetup } from './PageSetup/pageSetup';
import { PageConfigure } from './PageConfigure/pageConfigure';
import { PageFilters } from './PageFilters/pageFilters';
import './viewModal.scss';
import { Modal } from 'rcd-cpp-ui/ui/modal/Modal';
import { Buttons } from 'rcd-cpp-ui/ui/button/Buttons';
import { Cancel, Primary } from 'rcd-cpp-ui/ui/button';
import { useActions as useViewActions } from './viewModalActions';
import { Alert } from '../Alert/alert';
import { Loader } from '../Loader/loader';
import { ModalNav } from '../ModalNav/modalNav';
import { Setup, Configure, Sort, Display } from '../Icon/icon';
import { Filter } from 'rcd-cpp-ui/ui/icon/Filter';
import { Page } from '../../enums/Page';
import { ViewType } from '../../enums/ViewType';
import { PageDisplay } from './PageDisplay/pageDisplay';
import { useActions as useNavActions } from '../Nav/navActions';
import { useSelector } from '../../utils/useSelector';
import { PageSort } from './PageSort/pageSort';

const Pages = [
  { label: Page.Setup, Icon: Setup },
  { label: Page.Configure, Icon: Configure },
  { label: Page.Display, Icon: Display },
  { label: Page.Filters, Icon: Filter },
  { label: Page.Sort, Icon: Sort }
];

export const ViewModal = () => {
  const page = useSelector(s => s.viewModal?.page);
  const refId = useSelector(s => s.viewModal?.refId);
  const viewType = useSelector(s => s?.viewModal?.viewType);
  const isEFSBuilder = useSelector(s => s?.viewModal?.isEFSBuilder);
  const selectedWorkspace = useSelector(s => s.planning?.selectedWorkspace);
  const { navigate } = useNavActions();
  const { closeViewModal, nextPage, prevPage, goToPage, save } =
    useViewActions();

  const pages = React.useMemo(() => {
    if (isEFSBuilder) {
      return Pages.filter(p => [Page.Setup, Page.Display].includes(p.label));
    }
    if (viewType == ViewType.Tabular) {
      return Pages.filter(p => p.label != Page.Configure);
    }
    return Pages;
  }, [viewType, isEFSBuilder]);

  if (!page) return null;
  const lastPage = pages[pages.length - 1].label;
  return (
    <Modal
      id="viewModal"
      header={refId ? 'Edit View' : 'Add a New View'}
      onClose={closeViewModal}
      footer={
        <Buttons>
          <Cancel onClick={closeViewModal} />
          {page != lastPage && (
            <Primary label="Continue" onClick={() => nextPage(pages)} />
          )}
          {(page == lastPage || !!refId) && (
            <Primary
              label={refId ? 'Save' : 'Create View'}
              onClick={() => {
                save().then((viewRefId: any) => {
                  if (viewRefId != null)
                    navigate(selectedWorkspace, { v: viewRefId });
                });
              }}
            />
          )}
        </Buttons>
      }
    >
      <div className="plan-modal modal-with-nav">
        <Loader id="viewModalLoader" />
        <Alert id="viewModalAlert" />
        <ModalNav
          selectedPage={page}
          pages={pages}
          goToPage={p => goToPage(pages, p.label)}
          prevPage={() => prevPage(pages)}
        />
        <div>
          {page == Page.Setup && <PageSetup />}
          {page == Page.Configure && <PageConfigure />}
          {page == Page.Display && <PageDisplay />}
          {page == Page.Sort && <PageSort />}
          {page == Page.Filters && <PageFilters />}
        </div>
      </div>
    </Modal>
  );
};
